import Axios from 'axios';

export default {

  // 活动列表
  list() {
    return Axios.get('/activity/api/admin/list');
  },

  // 活动推送
  push(
    id
  ) {
    return Axios.put(`/activity/api/admin/${id}/publish`);
  },

  // 活动上线下线切换
  switchStatus(
    id
  ) {
    return Axios.put(`/activity/api/admin/${id}/disableorenable`);
  },

  // 新增活动
  add(
    title,
    start_time,
    end_time,
    banner,
    community_ids,
    status,
    score,
    address,
    places,
    signup_end_time,
    content,
    desc,
    fields
  ) {
    return Axios.post('/activity/api/admin/', {
      title,
      start_time,
      end_time,
      banner,
      community_ids,
      status,
      score,
      address,
      places,
      signup_end_time,
      content,
      desc,
      fields
    });
  },

  // 编辑活动
  edit(
    id,
    title,
    start_time,
    end_time,
    banner,
    community_ids,
    status,
    score,
    address,
    places,
    signup_end_time,
    content,
    desc,
    fields
  ) {
    return Axios.put(`/activity/api/admin/${id}`, {
      title,
      start_time,
      end_time,
      banner,
      community_ids,
      status,
      score,
      address,
      places,
      signup_end_time,
      content,
      desc,
      fields
    });
  },

  // 删除活动
  del(
    ids
  ) {
    return Axios.delete('/activity/api/admin/', {
      data: {
        ids
      }
    });
  },

  // 活动详情
  info(
    id
  ) {
    return Axios.get(`/activity/api/admin/${id}`, {
      params: {
        include: 'fields'
      }
    });
  },

  // 列表ids
  listIds(
    id
  ) {
    return Axios.get(`/activity/api/admin/${id}/platform`);
  },

  // 报名分页列表
  signUpListPage(
    id,
    name,
    page,
    per_page
  ) {
    return Axios.get(`/activity/api/admin/${id}/signupusers`, {
      params: {
        name,
        page,
        per_page
      }
    });
  }

}